export const PAGE_PROPS = {
    list: [],
    totalPages: 0,
    totalRecords: 0,
};

export const API_SEARCH_PAYLOAD = {
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    isDescending: false,
    sortingOn: "",
};
